/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import moment from 'moment';
import TSBeitraegeSearchresultDTO from '../../models/TSBeitraegeSearchresultDTO';
import TSBeitrag from '../../models/TSBeitrag';
import TSBeitragPreFilterDTO from '../../models/TSBeitragPreFilterDTO';
import DateUtil from '../../utils/DateUtil';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Beitrag Angaben
 *
 */
export default class BeitragRS {
    serviceURL: string;

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];

    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
        this.serviceURL = this.CONSTANTS.REST_API + 'beitrag';
    }

    public saveSchadenfallBeitrag(schadenfallId: string, beitrag?: TSBeitrag): IPromise<TSBeitrag | undefined> {
        if (beitrag) {
            let restBeitrag: any = beitrag.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'beitrag/schadenfallbeitrag/' + encodeURIComponent(schadenfallId), restBeitrag)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSBeitrag().deserialize(response.data);
                    }
                    return undefined;

                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public saveVersicherungsbeitragBeitrag(VersicherungsbeitragId: string, beitrag?: TSBeitrag): IPromise<TSBeitrag | undefined> {
        if (beitrag) {
            let restBeitrag: any = beitrag.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'beitrag/versicherungsbeitrag/' + encodeURIComponent(VersicherungsbeitragId), restBeitrag)
                .then((response: any) => {
                    if (response.data !== undefined) {
                        return new TSBeitrag().deserialize(response.data);
                    }
                    return undefined;

                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public deleteBeitrag(beitrag: TSBeitrag): IPromise<any> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'beitrag/' + encodeURIComponent(beitrag.id))
            .then((response) => {
                return response;
            });
    }

    public searchBeitraege(beitraegeSearch: any, prefilter: TSBeitragPreFilterDTO): IPromise<TSBeitraegeSearchresultDTO> {
        beitraegeSearch.prefilter = prefilter;
        return this.$http.post(this.serviceURL + '/search/', beitraegeSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING beitraege REST array object', response.data);
            return new TSBeitraegeSearchresultDTO().deserialize(response.data);
        });
    }

    public beitraegeFreigeben(ids: Array<string>) {
        return this.$http.post(this.serviceURL + '/freigeben/', ids, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            return response;
        });
    }

    public beitraegeAusfuehren(ids: Array<string>, ref: string, datumFaellig: moment.Moment) {
        return this.$http.post(this.serviceURL + '/ausfuehren/' + ref + '/' + DateUtil.momentToLocalDate(datumFaellig), ids, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            return response;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/BeitragRS.ts